import React from 'react';
import styled from 'styled-components';
import { Checkbox } from '@mui/material';

function CheckBoxComponent(props: ICheckBox) {
    return (
        <CheckBoxWrapTag block={props.block}>
            {props.list.map((item, index) => (
                <CheckBoxLabelTag key={index}>
                    <Checkbox
                        value={item.value}
                        checked={props.checked?.length > 0 && props.checked.includes(item.value) ? true : false}
                        onChange={props.onChange}
                        icon={<CheckBoxTag />}
                    />
                    <span>{item.name}</span>
                </CheckBoxLabelTag>
            ))}
        </CheckBoxWrapTag>
    );
}

export default React.memo(CheckBoxComponent);

export const CheckBoxWrapTag = styled.div<ICheckBoxWrapTag>`
    display: ${({ block }) => (block ? 'flex' : 'inline-flex')};
`;

export const CheckBoxLabelTag = styled.label`
    display: inline-flex;
    align-items: center;
    cursor: pointer;
    & > span:last-child {
        font-size: 14px;
    }
`;

export const CheckBoxTag = styled.div`
    width: 20px;
    height: 20px;
    margin: 2px 2px;
    border: 1px solid ${({ theme }) => theme.color.borderDefault};
    border-radius: 3px;
`;

/**
 * CheckBox interface
 */
export interface ICheckBox {
    /**
     * 이름
     */
    name: string;
    /**
     * display Block 여부 (기본 inline)
     */
    block?: Boolean;

    checked?: any;
    /**
     * 선택불가처리
     */
    disabled?: boolean;
    /**
     * 데이터
     */
    list: { name: string; value: string }[];
    /**
     * 기본 선택 값
     */
    defaultValue?: string[];

    onChange?: React.ChangeEventHandler;
}

export interface ICheckBoxWrapTag extends Pick<ICheckBox, 'block'> {}
